(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.PolygonCropper = {}));
}(this, (function (exports) { 'use strict';

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	var script = {
		name: "PolygonCrop",
		props: {
			canvasClass: {
				type: String,
				default: ""
			},
			width: {
				type: Number,
				default: 0
			},
			height: {
				type: Number,
				default: 0
			},
			wrapperClass: {
				type: String,
				default: ""
			},
			pointerClass: {
				type: String,
				default: ""
			},
			imageSource: {
				type: String,
				default: ""
			},
			showCanvas: {
				type: Boolean,
				default: true
			},
			showPointer: {
				type: Boolean,
				default: true
			}
		},
		data: function data() {
			return {
				editing: 1,
				imageObj: null,
				positionX: '',
				positionY: '',
				oldPositionX: '',
				oldPositionY: '',
				ctx: null,
				imageCanvas: null,
				redoMarks: [],
				undoMarks: [],
				currentMarks: [],
				redoList: [],
				undoList: [],
				redoPointer: [],
				undoPointer: [],
				currentPointer: [],
				resultImage: null,
				imgWidth: 0,
				imgHeight: 0
			};
		},
		mounted: function mounted() {
			this._initialize();
		},
		methods: {
			_initialize: function () {
				var this$1 = this;

				this.imageCanvas = this.$refs.canvas;
				this.ctx = this.imageCanvas.getContext("2d");
				var img = new Image();
				img.onload = function () {
					this$1.imgWidth = this$1.width > 0 ? this$1.width : img.width;
					this$1.imgHeight = this$1.height > 0 ? this$1.height : img.height;
					this$1.ctx.canvas.width = this$1.imgWidth;
					this$1.ctx.canvas.height = this$1.imgHeight;
					this$1.ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, this$1.imgWidth, this$1.imgHeight);

					var canvasImg = new Image();
					canvasImg.src = this$1.imageCanvas.toDataURL();
					canvasImg.onload = function () {
						this$1.imageObj = canvasImg;
					};
				};
				img.src = this.imageSource;

			},
			empty: function () {
				this.redoList = [];
				this.undoList = [];
				this.redoPointer = [];
				this.undoPointer = [];
				this.currentPointer = [];
				this.redoMarks = [];
				this.undoMarks = [];
				this.currentMarks = [];
			},
			reset: function () {
				this.empty();
				this.imageObj = null;
				this.resultImage = null;
				this.editing = 1;
				this._initialize();
			},
			savePointer: function (point) {
				this.redoPointer = [];
				this.currentPointer.push(point);
				this.undoPointer.push(point);
			},
			restorePointer: function (pop, push, undo) {
				if (pop.length > 0) {
					var item = pop.pop();
					push.push(item);
					if (undo) {
						this.oldPositionX = item.positionX;
						this.oldPositionY = item.positionY;
						this.currentPointer.pop();
					} else {
						if (this.redoPointer.length > 0) {
							this.oldPositionX = this.redoPointer[this.redoPointer.length - 1]['positionX'];
							this.oldPositionY = this.redoPointer[this.redoPointer.length - 1]['positionY'];
						}
						this.currentPointer.push(item);
					}
				}
			},
			restoreMarks: function (pop, push, undo) {
				var ref;

				if (pop.length > 1) {
					var item = pop.splice(pop.length - 2, 2);
					push.push.apply(push, item);
					if (undo) {
						this.currentMarks.splice(pop.length - 2, 2);
					} else {
						(ref = this.currentMarks).push.apply(ref, item);
					}
				}
			},
			saveState: function (canvas, list, keepRedo) {
				keepRedo = keepRedo || false;
				if (!keepRedo) {
					this.redoList = [];
				}
				(list || this.undoList).push(canvas.toDataURL());
			},
			restoreState: function (pop, push) {
				var this$1 = this;

				if (pop.length) {
					this.saveState(this.imageCanvas, push, true);
					var restoreState = pop.pop();
					var img = new Image();
					img.src = restoreState;
					img.onload = function () {
						this$1.ctx.clearRect(0, 0, this$1.imgWidth, this$1.imgHeight);
						this$1.ctx.drawImage(img, 0, 0);
					};
				}
			},
			undo: function () {
				if (this.editing) {
					this.editing = 0;
					this.restoreState(this.undoList, this.redoList);
					this.restorePointer(this.undoPointer, this.redoPointer, true);
					this.restoreMarks(this.undoMarks, this.redoMarks, true);
					this.editing = 1;
				}
			},
			redo: function () {
				if (this.editing) {
					this.editing = 0;
					this.restoreState(this.redoList, this.undoList);
					this.restorePointer(this.redoPointer, this.undoPointer, false);
					this.restoreMarks(this.redoMarks, this.undoMarks, false);
					this.editing = 1;
				}
			},
			crop: function () {
				var this$1 = this;

				if (this.editing) {
					this.currentPointer = [];
					this.ctx.clearRect(0, 0, this.imgWidth, this.imgHeight);
					this.ctx.beginPath();
					this.ctx.globalCompositeOperation = 'destination-over';
					var left = this.imageCanvas.offsetLeft;
					var top = this.imageCanvas.offsetTop;
					for (var i = 0; i < this.currentMarks.length; i += 2) {
						var x = this.currentMarks[i];
						var y = this.currentMarks[i + 1];
						if (i === 0) {
							this.ctx.moveTo(x - left, y - top);
						} else {
							this.ctx.lineTo(x - left, y - top);
						}
					}
					this.ctx.fillStyle = this.ctx.createPattern(this.imageObj, "repeat");
					this.ctx.fill();
					var trimmedCanvas = this.trimEmptyPixel(this.imageCanvas, this.ctx);
					var dataUrl = trimmedCanvas.toDataURL("image/png");
					this.resultImage = dataUrl;
					this.editing = 0;
					var img = new Image();
					img.onload = function () {
						this$1.ctx.canvas.width = img.width;
						this$1.ctx.canvas.height = img.height;
						this$1.ctx.drawImage(img, 0, 0);
					};
					img.src = dataUrl;
					this.empty();
				}

			},
			mouseDown: function (e) {
				if (this.editing === 1) {
					if (e.which === 1) {
						//store the points if mousedown
						if (this.oldPositionX !== '' && this.undoList.length > 0) {
							this.ctx.beginPath();
							this.ctx.moveTo(this.oldPositionX, this.oldPositionY);
							this.ctx.lineTo(this.positionX, this.positionY);
							this.ctx.strokeStyle = "#F63E02";
							this.ctx.lineWidth = 2;
							this.ctx.setLineDash([1, 1]);
							this.ctx.stroke();
						}
						this.redoMarks = [];
						this.currentMarks.push(e.pageX, e.pageY);
						this.undoMarks.push(e.pageX, e.pageY);
						this.saveState(this.imageCanvas);
						this.savePointer({
							x: e.pageX + 'px',
							y: e.pageY + 'px',
							positionX: e.offsetX,
							positionY: e.offsetY
						});

						this.oldPositionX = e.offsetX;
						this.oldPositionY = e.offsetY;
					}
					this.positionX = e.offsetX;
					this.positionY = e.offsetY;
				}
			},
			mouseMove: function (e) {
				if (this.editing === 1) {
					this.positionX = e.offsetX;
					this.positionY = e.offsetY;
				}
			},
			trimEmptyPixel: function (c, ctx) {
				var copy = document.createElement('canvas').getContext('2d'),
					pixels = ctx.getImageData(0, 0, c.width, c.height),
					l = pixels.data.length,
					i,
					bound = {
						top: null,
						left: null,
						right: null,
						bottom: null
					},
					x, y;
				for (i = 0; i < l; i += 4) {
					if (pixels.data[i + 3] !== 0) {
						x = (i / 4) % c.width;
						y = ~~((i / 4) / c.width);

						if (bound.top === null) {
							bound.top = y;
						}

						if (bound.left === null) {
							bound.left = x;
						} else if (x < bound.left) {
							bound.left = x;
						}

						if (bound.right === null) {
							bound.right = x;
						} else if (bound.right < x) {
							bound.right = x;
						}

						if (bound.bottom === null) {
							bound.bottom = y;
						} else if (bound.bottom < y) {
							bound.bottom = y;
						}
					}
				}

				// Calculate the height and width of the content
				var trimHeight = bound.bottom - bound.top,
					trimWidth = bound.right - bound.left,
					trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

				copy.canvas.width = trimWidth;
				copy.canvas.height = trimHeight;
				copy.putImageData(trimmed, 0, 0);
				return copy.canvas;
			},
		},
		watch: {
			imageSource: function (val) {
				this.empty();
				this._initialize();
			},
		}
	};

	function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
	/* server only */
	, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
	  if (typeof shadowMode !== 'boolean') {
	    createInjectorSSR = createInjector;
	    createInjector = shadowMode;
	    shadowMode = false;
	  } // Vue.extend constructor export interop.


	  var options = typeof script === 'function' ? script.options : script; // render functions

	  if (template && template.render) {
	    options.render = template.render;
	    options.staticRenderFns = template.staticRenderFns;
	    options._compiled = true; // functional template

	    if (isFunctionalTemplate) {
	      options.functional = true;
	    }
	  } // scopedId


	  if (scopeId) {
	    options._scopeId = scopeId;
	  }

	  var hook;

	  if (moduleIdentifier) {
	    // server build
	    hook = function hook(context) {
	      // 2.3 injection
	      context = context || // cached call
	      this.$vnode && this.$vnode.ssrContext || // stateful
	      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
	      // 2.2 with runInNewContext: true

	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__;
	      } // inject component styles


	      if (style) {
	        style.call(this, createInjectorSSR(context));
	      } // register component module identifier for async chunk inference


	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier);
	      }
	    }; // used by ssr in case component is cached and beforeCreate
	    // never gets called


	    options._ssrRegister = hook;
	  } else if (style) {
	    hook = shadowMode ? function () {
	      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
	    } : function (context) {
	      style.call(this, createInjector(context));
	    };
	  }

	  if (hook) {
	    if (options.functional) {
	      // register for functional component in vue file
	      var originalRender = options.render;

	      options.render = function renderWithStyleInjection(h, context) {
	        hook.call(context);
	        return originalRender(h, context);
	      };
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate;
	      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
	    }
	  }

	  return script;
	}

	var normalizeComponent_1 = normalizeComponent;

	var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
	function createInjector(context) {
	  return function (id, style) {
	    return addStyle(id, style);
	  };
	}
	var HEAD = document.head || document.getElementsByTagName('head')[0];
	var styles = {};

	function addStyle(id, css) {
	  var group = isOldIE ? css.media || 'default' : id;
	  var style = styles[group] || (styles[group] = {
	    ids: new Set(),
	    styles: []
	  });

	  if (!style.ids.has(id)) {
	    style.ids.add(id);
	    var code = css.source;

	    if (css.map) {
	      // https://developer.chrome.com/devtools/docs/javascript-debugging
	      // this makes source maps inside style tags work properly in Chrome
	      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

	      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
	    }

	    if (!style.element) {
	      style.element = document.createElement('style');
	      style.element.type = 'text/css';
	      if (css.media) { style.element.setAttribute('media', css.media); }
	      HEAD.appendChild(style.element);
	    }

	    if ('styleSheet' in style.element) {
	      style.styles.push(code);
	      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
	    } else {
	      var index = style.ids.size - 1;
	      var textNode = document.createTextNode(code);
	      var nodes = style.element.childNodes;
	      if (nodes[index]) { style.element.removeChild(nodes[index]); }
	      if (nodes.length) { style.element.insertBefore(textNode, nodes[index]); }else { style.element.appendChild(textNode); }
	    }
	  }
	}

	var browser = createInjector;

	/* script */
	var __vue_script__ = script;

	/* template */
	var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClass},[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCanvas),expression:"showCanvas"}],ref:"canvas",class:_vm.canvasClass,on:{"mousedown":_vm.mouseDown,"mousemove":_vm.mouseMove}}),_vm._v(" "),_vm._l((_vm.currentPointer),function(point){return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPointer),expression:"showPointer"}],class:("vue-crop-pointer " + _vm.pointerClass),style:({top:point.y, left:point.x})})})],2)};
	var __vue_staticRenderFns__ = [];

	  /* style */
	  var __vue_inject_styles__ = function (inject) {
	    if (!inject) { return }
	    inject("data-v-642f2e8f_0", { source: ".vue-crop-pointer{border:solid 1px #000;filter:alpha(opacity=50);opacity:.5;position:absolute;width:5px;height:5px}canvas{position:relative;margin-left:0;margin-top:0;cursor:crosshair}", map: undefined, media: undefined });

	  };
	  /* scoped */
	  var __vue_scope_id__ = undefined;
	  /* module identifier */
	  var __vue_module_identifier__ = undefined;
	  /* functional template */
	  var __vue_is_functional_template__ = false;
	  /* style inject SSR */
	  

	  
	  var component = normalizeComponent_1(
	    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
	    __vue_inject_styles__,
	    __vue_script__,
	    __vue_scope_id__,
	    __vue_is_functional_template__,
	    __vue_module_identifier__,
	    browser,
	    undefined
	  );

	function install(Vue) {
		if (install.installed) { return; }
		install.installed = true;
		Vue.component("PolygonCrop", component);
	}

	var plugin = {
		install: install
	};

	var GlobalVue = null;
	if (typeof window !== "undefined") {
		GlobalVue = window.Vue;
	} else if (typeof global !== "undefined") {
		GlobalVue = global.vue;
	}

	if (GlobalVue) {
		GlobalVue.use(plugin);
	}

	component.install = install;

	exports.default = component;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
